import React from 'react';
//@ts-ignore
import { FilterContext } from './FilterKeyRoot';

const submitTimeoutIntervalInMS = 500;

export interface UseFilterKeyProps {
  filterKey?: string;
  setFilterKey?: Function;
  render: Function;
  loadData?: Function;
  disableRealTimeFilter?: boolean;
}

export interface UseFilterKeyState {
  filterInput: string;
  filterKey: string;
}

class UseFilterKey extends React.Component<UseFilterKeyProps, UseFilterKeyState> {
  private submitTimeout: ReturnType<typeof setTimeout>;
  static defaultProps = {
    loadData: (): void => {},
    setFilterKey: (key: string, val: boolean): void => {},
    disableRealTimeFilter: true,
    filterKey: '',
  };
  constructor(props: UseFilterKeyProps) {
    super(props);
    this.state = {
      filterInput: props.filterKey || '',
      filterKey: props.filterKey,
    };
    this.submitTimeout = null;
  }

  componentDidMount(): void {
    const { filterKey } = this.state;
    const { loadData } = this.props;
    loadData(filterKey);
  }

  static getDerivedStateFromProps(nextProps: UseFilterKeyProps, prevState: Readonly<UseFilterKeyState>): UseFilterKeyState  {
    if (nextProps.filterKey !== prevState.filterKey) {
      return { filterKey: nextProps.filterKey, filterInput: (nextProps.filterKey || '') };
    }
    return null;
  }

  componentDidUpdate(prevProps: Readonly<UseFilterKeyProps>, prevState: Readonly<UseFilterKeyState>, snapshot: any): void {
    const { filterKey } = this.state;
    const { loadData } = this.props;
    if (prevState.filterKey !== filterKey) {
      loadData(filterKey);
    }
  }

  handleFilterChange = (event: React.MouseEvent<HTMLElement>): void => {
    const { disableRealTimeFilter } = this.props;
    const { value } = (event.target as HTMLInputElement);
    this.setState({ filterInput: value }, () => {
      if (!disableRealTimeFilter) {
        clearTimeout(this.submitTimeout);
        this.submitTimeout = setTimeout(() => { this.handleFilterSubmit(event); }, submitTimeoutIntervalInMS);
      }
    });
  };

  handleFilterSubmit = (event: React.MouseEvent<HTMLElement>): void => {
    const { filterInput } = this.state;
    const newKey = filterInput;
    const { setFilterKey } = this.props;
    setFilterKey(newKey, false);
    !!event && event.preventDefault();
  };

  render() {
    const { render } = this.props;
    return render(
      {
        ...this.state,
        handleFilterChange: this.handleFilterChange,
        handleFilterSubmit: this.handleFilterSubmit,
      },
    );
  }
}

export default (props: UseFilterKeyProps) => (
  // props provide render (render props pattern) and loadData from data view
  // context provides filterKey and setFilterKey from MainContainer
  <FilterContext.Consumer>
    {(context: UseFilterKeyProps) => (<UseFilterKey {...props} {...context} />)}
  </FilterContext.Consumer>
);

export function frontendFilter(items: {title: string; description: string}[], filterInput: string, fields = ['title', 'description']) {
  filterInput = filterInput.toUpperCase();
  return items.filter((item) => {
    for (let i = 0; i < fields.length; i += 1) {
      //@ts-ignore
      if ((item[fields[i]] || '').toUpperCase().includes(filterInput)) return true;
    }
    return false;
  });
}
